module.exports = __webpack_public_path__ + "static/media/stress_token.30676a66.png";